<template>
  <flash-message></flash-message>
  <router-view></router-view>
</template>

<script setup>
import {onErrorCaptured} from 'vue';
import {useRouter, useRoute} from 'vue-router';
import FlashMessage from '../components/FlashMessage.vue';
import UnauthenticatedError from '../errors/UnauthenticatedError.js';

const router = useRouter();
const route = useRoute();

onErrorCaptured(async err => {
  if (err instanceof UnauthenticatedError) {
    // Check if we're in admin area to redirect to appropriate login
    if (route.path.startsWith('/admin')) {
      await router.push({name: 'admin.login'});
    } else {
      await router.push({name: 'login'});
    }
  }
});
</script>

<style scoped></style>